import { render } from "./BlFormFieldColor.vue?vue&type=template&id=227b1e48&scoped=true"
import script from "./BlFormFieldColor.vue?vue&type=script&lang=js"
export * from "./BlFormFieldColor.vue?vue&type=script&lang=js"

import "./BlFormFieldColor.vue?vue&type=style&index=0&id=227b1e48&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227b1e48"]])

export default __exports__